export const stripeUrl = id => `https://dashboard.stripe.com/customers/${id}`;